import { render } from "./upload.vue?vue&type=template&id=66afef91"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/upload.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66afef91"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66afef91', __exports__)) {
    api.reload('66afef91', __exports__)
  }
  
  module.hot.accept("./upload.vue?vue&type=template&id=66afef91", () => {
    api.rerender('66afef91', render)
  })

}


export default __exports__